import styled from "styled-components";

import DropdownMenuGroup from "../DropdownMenuGroup/DropdownMenuGroup";
import DropdownMenuTextLink from "../DropdownMenuTextLink/DropdownMenuTextLink";
import NavbarDropdown from "../NavbarDropdown/NavbarDropdown";
import Trigger from "../Trigger/Trigger";
import { AccountsDropdownIds } from "Header/NavbarRevamp/navbarRevamp.ids";
import messages from "Header/NavbarRevamp/constants/navbarRevamp.messages";
import createAbsolutePath from "createAbsolutePath";
import { AccountPrimaryFragment, ActiveProfileQuery } from "operations";
import { useFlags } from "launchdarkly-react-client-sdk";

const AccountDropdownContainer = styled.div`
  display: flex;
`;

const label = (account: AccountPrimaryFragment) =>
  `${account.name} (${account.id})`;

const AccountDropdown = ({ account }: Pick<ActiveProfileQuery, "account">) => {
  const { showRetailIntegrationsSettings } = useFlags();

  return (
    <AccountDropdownContainer>
      <NavbarDropdown
        rightPosition
        trigger={
          <Trigger
            label={label(account)}
            id={AccountsDropdownIds.AccountsTrigger}
          />
        }
      >
        <DropdownMenuGroup>
          {showRetailIntegrationsSettings && (
            <DropdownMenuTextLink
              to={createAbsolutePath("/accounts/settings")}
              message={messages.mySettings}
              id={AccountsDropdownIds.AccountsOptionSettings}
            />
          )}
          <DropdownMenuTextLink
            to="https://help.jooraccess.com/en"
            message={messages.helpCenter}
            id={AccountsDropdownIds.AccountsOptionHelp}
          />
          <DropdownMenuTextLink
            to={createAbsolutePath("/users/logout")}
            message={messages.logout}
            id={AccountsDropdownIds.AccountsOptionLogout}
          />
        </DropdownMenuGroup>
      </NavbarDropdown>
    </AccountDropdownContainer>
  );
};

export default AccountDropdown;
